import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateBotsPrompt = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_BOTS_PROMPT' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/bot/prompt`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_BOTS_PROMPT_DONE',
            });
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            dispatch({
              type: 'UPDATING_BOTS_PROMPT_FAILED',
              payload: `Failed to update bots prompt`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_BOTS_PROMPT_FAILED',
            payload: `Failed to update bots prompt`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_BOTS_PROMPT_FAILED',
        payload: `Failed to update bots prompt`,
      });
    }
  };
};

export default updateBotsPrompt;
